<template>
    <el-card shadow="none" class="meeting-calendar" v-loading="process.loading">
        <div slot="header" class="clearfix">
            <el-date-picker class=""
                            size="medium"
                            v-model="target"
                            value-format="yyyy-MM-dd"
                            @change="reload"
                            type="month"
                            format="yyyy年M月"
                            placeholder="选择月">
            </el-date-picker>
            <div class="pull-right">
                <el-button-group>
                    <el-button type="default" style="padding: 10px 10px;" size="medium"
                               @click.native='previous' icon="el-icon-arrow-left"> 上个月
                    </el-button>
                    <el-button type="default" style="padding: 10px 10px;" size="medium"
                               @click.native='today'> 今天
                    </el-button>
                    <el-button type="default" style="padding: 10px 10px;" size="medium"
                               icon="el-icon-arrow-right"
                               @click.native='next'> 下个月
                    </el-button>
                </el-button-group>
            </div>
        </div>

        <!-- calendar -->
        <div class="calendar-body">
            <div class="wrapper">
                <div class="cell weekday" v-for="weekday in ['日','一','二','三','四','五','六']" :key="weekday">
                    <b> {{weekday}} </b>
                </div>
                <div class="cell" v-for="(item,date) in books" :key="date">
                    <div class="cell-date" :class="item.inactive?'text-inactive':''"> {{item['date'][2]}}</div>

                    <div class="book" v-show="index<4"
                         v-for="(resv,index) in item.books"
                         :class="resv.approve === '1'?'submitted':'approved'"
                         :key="resv.id">
                                            <span>{{resv.meeting_time.substr(0,2)}}
                                                <sup>{{resv.meeting_time.substr(-2)}}</sup>
                                            </span>
                        {{resv.host_name}}
                    </div>
                    <div class="details" v-if="item.books.length">
                        <el-button type="text" icon="el-icon-search"
                                   @click.native="showResv(item,date)">详细信息
                        </el-button>
                    </div>

                </div>

            </div>
        </div>
        <div class="clearfix"></div>

        <el-dialog :visible.sync="show_details" :close-on-click-modal="false">
            <div slot="title"><b class="text-info">{{single.date}} 的预约情况</b></div>
            <div class="meeting-detail-wrap">
                <div class="meeting-detail" v-for="(record,index) in single.records" :key="record.id">
                    <div class="circle-number">{{index+1}}</div>
                    <div class="meeting-inner">
                        <div class="name">({{record.id}}){{record.host_name}}
                            <small class="text-info ml-2">{{record.department}}
                                | {{record.approve === '1'?'提交':'批准'}}
                                <span class="text-danger" v-if="record.option_h323 === '1'"> | 使用H.323 </span>
                            </small>
                        </div>
                        <div class="time mt-1"><b>{{record.meeting_time}}</b> {{record.duration_hour}}
                            <span class="text-dark"> | {{record.room_name}}</span></div>
                        <div class="author mt-1">{{record.topic}}</div>

                    </div>
                    <div class="clearfix"></div>

                </div>

            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="show_details=false">关 闭</el-button>
            </div>

        </el-dialog>

    </el-card>

</template>

<script>

    import {mapState} from "vuex";

    export default {
        name: "meeting-monthview",
        data() {
            return {
                cell_width: 100,
                target: null,
                books: {},
                single: {},
                show_details: false
            }
        },
        created() {
            this.target = new Date().Format('yyyy-MM-dd');
        },
        mounted() {
            this.reload();
        },
        computed: {
            ...mapState(['process']),
        },
        methods: {
            next() {
                let date = this.$dateParse(this.target);
                date.setMonth(date.getMonth() + 1);
                this.target = date.Format('yyyy-MM-dd');
                this.reload();
            },
            previous() {
                let date = this.$dateParse(this.target);
                date.setMonth(date.getMonth() - 1);
                this.target = date.Format('yyyy-MM-dd');
                this.reload();
            },
            today() {
                let date = new Date();
                this.target = date.Format('yyyy-MM-dd');
                this.reload();
            },
            reload() {
                if (this.$is_date(this.target)) {
                    this.$api('Query.View.Month', {date: this.target}, true).then(res => {
                        this.books = res.data.data;
                    });
                }
            },
            showResv(record, date) {
                this.single.records = record.books;
                this.single.date = date;
                this.show_details = true;
            }
        }
    }
</script>

<style scoped lang="scss">

    $left-bar-bg-color: #f1f1f1;
    $right-bar-bg-color: white;
    $room-title-color: #2f3538;
    $room-email-color: #576B70;
    $room-bg-color: #f8f8f8;
    $title-color: #607d8b;
    $border-left-color: #9e9e9e;
    $border-color: #EBEEF5;

    button {
        outline: none;
    }

    .meeting-calendar {
        //border: 2px solid darken($border-color, 10%);

        .calendar-body {
            overflow-x: auto;
            position: relative;
            overflow-y: hidden;
            background-color: white;

            .wrapper {
                min-width: 700px;
                width: 100%;
                display: flex;
                flex-wrap: wrap;

                .cell {
                    width: 14.28%;
                    border-left: 1px solid $border-color;
                    position: relative;
                    border-bottom: 1px solid $border-color;
                    text-align: left;
                    box-sizing: border-box;
                    padding: 8px;
                    height: 148px;

                    .cell-date {
                        height: 24px;
                        background-color: #F5F5F5;
                        text-align: center;
                        margin: -7px -7px 5px -7px;
                        color: black;

                        &.text-inactive {
                            color: darken($border-color, 10%);
                        }
                    }

                    .day-text {
                        font-size: 30px;
                        line-height: 30px;
                        font-weight: 200;
                        color: $title-color;
                        margin: 17px 0 0 7px;

                        .week {
                            position: absolute;
                            bottom: 0;
                            width: 100%;
                            line-height: 10px;
                            left: 0;

                            span {
                                color: #576B70;
                                padding-left: 7px;
                                font-size: 16px;
                                font-weight: 500;
                                position: relative;
                                top: -10px;
                                display: block;
                            }
                        }
                    }

                    &.weekday {
                        height: 50px;
                        border-top: 1px solid transparent;
                        border-left: 1px solid transparent;
                        border-right: 1px solid transparent;
                        border-bottom: 1px solid $border-color;
                        text-align: center;
                    }

                    &:nth-child(14), &:nth-child(21), &:nth-child(28), &:nth-child(35),
                    &:nth-child(42), &:nth-child(49), &:nth-child(56) {
                        border-right: 1px solid $border-color;
                    }

                    .details {
                        position: absolute;
                        left: 0;
                        right: 0;
                        top: 25px;
                        bottom: 0;
                        text-align: center;
                        padding-top: 40px;
                        transition: opacity 0.2s ease-in;
                        background-color: rgba(240, 248, 255, 0.8);

                        opacity: 0;
                    }

                    &:hover {
                        .details {
                            display: block;
                            opacity: 1;
                        }
                    }

                    .book {
                        position: relative;
                        text-align: left;

                        display: block;
                        width: 100%;
                        height: 30px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        font-size: 14px;
                        line-height: 20px;
                        color: #576B70;

                        span {
                            font-family: Helvetica Neue, PingFang SC, Helvetica, Arial, Hiragino Sans GB, Microsoft Yahei, sans-serif;
                            display: inline-block;
                            position: relative;
                            top: 1px;
                            font-weight: 500;
                            padding: 0 2px;
                            color: #fff;
                            margin-left: 1px;
                        }


                        &.submitted {
                            span {
                                background-color: #1976d2;
                            }
                        }

                        &.approved {
                            span {
                                background-color: #388E3C;
                            }
                        }

                        &.other {
                            background-color: #FFF3E0;
                            border: 1px solid #cfd8dc;
                        }
                    }
                }


                .calender-meeting {
                    .calender-body-trow {
                        height: 80px;
                        position: relative;

                        .cell {
                            width: 14.28%;
                            height: 100%;
                            float: left;
                            border-left: 1px solid $border-left-color;
                            position: relative;
                            border-bottom: 1px solid $border-color;
                            user-select: none;


                        }
                    }
                }
            }
        }
    }

    .meeting-detail-wrap {
        .meeting-detail {
            border-bottom: 1px solid $border-color;
            margin-bottom: 15px;
            padding-bottom: 10px;

            .circle-number {
                width: 32px;
                height: 32px;
                border: 1px solid #607D8B;
                border-radius: 50%;
                line-height: 30px;
                text-align: center;
                font-size: 16px;
                color: #607D8B;
                float: left;
                font-weight: bold;
            }

            .meeting-inner {
                position: relative;
                user-select: none;
                font-weight: normal;
                padding-left: 64px;

                .name {
                    font-size: 16px;
                    font-weight: 600;
                    line-height: 16px;
                    color: #3a4245;
                    height: 18px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }

                .time {
                    font-size: 14px;
                    color: indianred;
                }

                .department {
                    font-size: 14px;
                }

                .author {
                    font-size: 14px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    color: #333;
                }

                .h323 {
                    position: absolute;
                    bottom: 0;
                    right: 2px;
                    font-size: 6px;
                    color: rgba(255, 0, 0, 0.2);
                }
            }

            &:last-child {
                border-bottom: 1px solid transparent;
            }
        }

    }

</style>
